import React from 'react'

const Arrow = ({
  width = 12,
  height = 11.186,
  color = '#f3f5f9',
  direction = 'left',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 11.186"
  >
    <path
      fill={color}
      opacity="0.6"
      d="M0,2.3,1.5.815,7.064,6.407,1.5,12,0,10.509l4.083-4.1Zm9.02,4.1-4.083,4.1L6.434,12,12,6.407,6.434.814,4.936,2.3Z"
      transform={
        direction === 'left' ? 'translate(12 12) rotate(180)' : undefined
      }
    />
  </svg>
)

export default Arrow
